import {
  GET_COMMON_CONFIG,
  GET_GEN_SUBJECT_AND_CODES,
  GET_COMMON_COURSE_AND_CODES,
  GET_COMMON_EXAMS,
  UPDATE_BACKDROP,
  GET_PERMS_MODULES,
} from 'actions/admin/config';

const initialState = {
  subjectCodes: [],
  commonConfigList: [],
  courseCodes: [],
  commonExams: [],
  isBackdropOpen: false,
  permModules: [],
};

export default function config(state = initialState, action = {}) {
  switch (action.type) {
    case GET_GEN_SUBJECT_AND_CODES:
      return { ...state, subjectCodes: action.subjectCodes };
    case GET_COMMON_CONFIG:
      return { ...state, commonConfigList: action.commonConfigList };
    case GET_COMMON_COURSE_AND_CODES: {
      return { ...state, courseCodes: action.courseCodes };
    }
    case GET_COMMON_EXAMS: {
      return { ...state, commonExams: action.commonExams };
    }
    case UPDATE_BACKDROP: {
      return { ...state, isBackdropOpen: action.isOpen };
    }
    case GET_PERMS_MODULES: {
      return { ...state, permModules: action.permModules };
    }
    default:
      return state;
  }
}
